import { RoomSettingConstants } from '@colonist/game-base-types';
import { RoomCreationPhase } from '@colonist/lobby-types';
export class RoomClientState {
    static deserialize(data) {
        const room = new RoomClientState();
        room.updateSequence = data.updateSequence;
        room.gameSetting = data.gameSetting;
        room.isTournament = data.isTournament;
        room.hostSession = data.hostSession;
        room.isTestFreeExpansionsAndMaps = data.isTestFreeExpansionsAndMaps;
        room.creationPhase = data.creationPhase;
        room.guests = data.guests;
        room.victoryPointsRecommendedLimit = data.victoryPointsRecommendedLimit;
        room.victoryPointsMaxAllowed = data.victoryPointsMaxAllowed;
        room.kickedUserIds = [
            ...data.kickedUserIds
        ];
        return room;
    }
    getSessionCount() {
        return this.guests.length + 1;
    }
    getSessions() {
        return [
            ...this.guests,
            this.hostSession
        ];
    }
    getGuestSessions() {
        return [
            ...this.guests
        ];
    }
    getUsernames() {
        return this.getSessions().map((session)=>session.username);
    }
    getUserIds() {
        const userIds = this.getSessions().map((session)=>session.userId);
        const filteredUserIds = userIds.filter((userId)=>userId != undefined);
        return filteredUserIds;
    }
    isInRoom(session) {
        for (const sessionInRoom of this.getSessions()){
            if (sessionInRoom.userSessionId == session.userSessionId) return true;
        }
        return false;
    }
    isMultiplayer() {
        for (const session of this.getGuestSessions()){
            if (!session.isBot) return true;
        }
        return false;
    }
    isHost(id) {
        return id == this.hostSession.userSessionId;
    }
    isHostSubscribed() {
        return this.hostSession.isMember;
    }
    isGuest(id) {
        return id != this.hostSession.userSessionId;
    }
    isPrivateGame() {
        return this.gameSetting.privateGame;
    }
    isNoTrollsGame() {
        return this.gameSetting.minimumKarma == RoomSettingConstants.NO_TROLLS_KARMA_THRESHOLD;
    }
    constructor(){
        this.creationPhase = RoomCreationPhase.EditSettings;
        this.victoryPointsRecommendedLimit = RoomSettingConstants.DEFAULT_VP_TO_WIN;
    }
}
